import React from "react"
import classNames from "classnames"
import {useTranslation} from "react-i18next"
import {Button, makeStyles, useMediaQuery, useTheme} from "@material-ui/core"

// HOCs
import withSignOut, {WithSignOutProps} from "../../hoc/withSignOut"
import Icon from "../../../../components/modern/Icon"

const useStyles = makeStyles({
    sign_out_button: {
        fontWeight: 600,
    },
    sign_out_button__icon: {
        minWidth: 40,
        width: 40,
        height: 40,
        padding: 0,
        borderRadius: "50%",
    },
    icon: {
        width: 18,
        height: 18,
    },
});

/**
 * @param props
 */
function SignOutButton(props: { className?: string } & WithSignOutProps) {
    const styles = useStyles();
    const [t] = useTranslation("common");
    const theme = useTheme();
    const compact = useMediaQuery(theme.breakpoints.down("xs"));

    return (
        <Button
            color="secondary"
            variant="contained"
            onClick={props.signOut}
            aria-label={t("sign_out")}
            title={compact ? t("sign_out") : undefined}
            className={classNames(
                styles.sign_out_button,
                compact && styles.sign_out_button__icon,
                props.className,
                "sing_out_button",
            )}
        >
            {compact ? <Icon name="signout" className={styles.icon}/> : t("sign_out")}
        </Button>
    )
}

export default withSignOut(SignOutButton)
